<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col class="mb-1">
          <div class="btn-group float-left">
            <router-link
              tag="button"
              class="btn btn-sm btn-warning"
              :to="{ name: 'EXSBMessagesPeriodicUpdate', params: { id: retrieved['@id'] }}"
            >{{$t('buttons.edit')}}</router-link>
            <button type="button" class="btn btn-sm btn-danger" @click="deleteItem(retrieved)">
              {{$t('buttons.delete')}}
            </button>
          </div>
          <router-link
            :to="{ name: 'EXSBMessagesPeriodicList' }"
            class="btn btn-sm btn-default float-right"
          >{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div v-if="isLoading">
            <Loader />
          </div>
          <div v-else>
            <b-card>
              <b-row>
                <b-col cols="12">
                  <p v-if="retrieved.title">{{ $t('views.exsbmessagesperiodic.form.title') }}:
                    <b>{{retrieved.title}}</b></p>
                  <p v-if="retrieved.description">{{ $t('views.exsbmessagesperiodic.form.description') }}:
                    <b>{{retrieved.description}}</b></p>
                  <p v-if="retrieved.mailTitle">{{ $t('views.exsbmessagesperiodic.form.mailTitle') }}:
                    <b>{{retrieved.mailTitle}}</b></p>
                  <p v-if="retrieved.mailBody">{{ $t('views.exsbmessagesperiodic.form.mailBody') }}:</p>
                    <hr>
                    <div v-html="retrieved.mailBody"></div>
                    <hr>
                  <p v-if="retrieved.taskType">{{ $t('views.excmcyclictask.form.taskType') }}:
                    <b>{{retrieved.taskType.title || ''}}</b></p>
                  <p v-if="retrieved.caseType">{{ $t('views.excmcyclictask.form.caseType') }}:
                    <b>{{retrieved.caseType.title || ''}}</b></p>
                  <p v-if="retrieved.firingThrough">{{ $t('views.exsbmessagesperiodic.form.firingThrough.label') }}:
                    <b>{{getFiringThroughText(retrieved.firingThrough) || ''}}</b></p>
                  <div class="align-top d-inline" v-if="retrieved.recipientType && retrieved.recipientType.length > 0">
                    {{ $t('views.exsbmessagesperiodic.form.recipientType') }}: </div>
                  <div class="d-inline-block">
                    <div v-for="recipient in retrieved.recipientType" :key="recipient">
                      <b>{{getRecipientTypeText(recipient)}}</b>
                    </div>
                  </div>
                  <div class="align-top d-inline" v-if="retrieved.recipientTypeCc && retrieved.recipientTypeCc.length > 0">
                    {{ $t('views.exsbmessagesperiodic.form.recipientTypeCc') }}: </div>
                  <div class="d-inline-block">
                    <div v-for="recipient in retrieved.recipientTypeCc" :key="recipient">
                      <b>{{getRecipientTypeText(recipient)}}</b>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Loader from '@/components/Dashboard/Layout/Loader'

export default {
  name: 'Show',
  components: {
    Loader
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    ...mapGetters({
      retrieved: 'exsbmessagesperiodic/show/retrieved',
      isLoading: 'exsbmessagesperiodic/show/isLoading',
      firingThroughOptions: 'exsbmessagesperiodic/list/firingThroughOptions',
      recipientTypeOptions: 'exsbmessagesperiodic/list/recipientTypeOptions'
    })
  },
  created () {
    this.retrieve(this.id)
  },
  methods: {
    getFiringThroughText (val) {
      return this.firingThroughOptions.find(option => parseInt(val) === option.value).text
    },
    getRecipientTypeText (val) {
      return this.recipientTypeOptions.find(option => parseInt(val) === option.value).text
    },
    ...mapActions({
      retrieve: 'exsbmessagesperiodic/show/retrieve',
      del: 'exsbmessagesperiodic/del/del'
    }),
    deleteItem (item) {
      this.$Swal({
        title: this.$t('notifications.deleteTitle'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.del(item['@id']).then(() => this.$router.push({ name: 'EXSBMessagesPeriodicList' }))
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
